module.exports = __webpack_public_path__ + "img/202502120201.a1a168a0.png";